export function flattenPoints(section) {
    const out = [];
    const walk = (p) => { out.push(p); p.children?.forEach(walk); };
    section.points.forEach(walk);
    return out;
}
/** A point's score: percent as is; pass = 100, fail = 0; na / empty = not evaluated. */
export function pointScore(p, r) {
    if (!r)
        return null;
    if (p.mode === "percent")
        return r.pct == null ? null : Math.max(0, Math.min(100, r.pct));
    if (r.check === "pass")
        return 100;
    if (r.check === "fail")
        return 0;
    return null;
}
/** Section / run score = average of evaluated leaf points (matches the Excel "avancement moyen contrôlé"). */
export function sectionScore(section, results) {
    const leaves = flattenPoints(section).filter((p) => !p.children?.length);
    const scores = leaves.map((p) => pointScore(p, results[p.code])).filter((s) => s !== null);
    return { score: scores.length ? Math.round((scores.reduce((a, b) => a + b, 0) / scores.length) * 10) / 10 : null, evaluated: scores.length, total: leaves.length };
}
export function runScore(body, results) {
    const parts = body.sections.map((s) => sectionScore(s, results));
    const evaluated = parts.reduce((a, p) => a + p.evaluated, 0);
    const total = parts.reduce((a, p) => a + p.total, 0);
    const weighted = parts.filter((p) => p.score !== null).reduce((a, p) => a + p.score * p.evaluated, 0);
    return { score: evaluated ? Math.round((weighted / evaluated) * 10) / 10 : null, evaluated, total };
}
export const ATTENDANCE_STATUSES = ["present", "absent", "leave", "sick", "mission", "half_day"];
export const MISSION_ORDER_STATES = ["issued", "arrived", "returned", "cancelled"];
//# sourceMappingURL=checklist.js.map